import {
  CheckboxIndeterminate,
  CheckmarkFilled,
  CheckmarkFilledError,
  Edit,
  RetryFailed,
  TrashCan,
} from "@carbon/icons-react";
import {
  CurrencyDisplay,
  CopyButton,
  SwitchAppIconButton,
} from "../../../../../../components";
import { truncateStringWithEllipsis } from "../../../../../../utils";
import { ICreateGatewayTransfer } from "../../../../../../interfaces-and-types";
import { memo } from "react";

interface IBatchGatewayTransferEntryStructuredListItemProps {
  transfer: ICreateGatewayTransfer;
  index: number;
  isLoadingBatchListVerification: boolean;
  batchListCount: number;
  removeGatewayTransferByIndex: (index: number) => void;
  toggleGatewayTransferBatchEntryEditMode: (index: number) => void;
  reVerifyTransfers: () => void;

  virtualizedListStyle?: any;
}

export const BatchGatewayTransferEntryStructuredListItem = memo(
  ({
    transfer,
    index,
    isLoadingBatchListVerification,
    batchListCount,
    removeGatewayTransferByIndex,
    toggleGatewayTransferBatchEntryEditMode,
    reVerifyTransfers,
    virtualizedListStyle,
  }: IBatchGatewayTransferEntryStructuredListItemProps) => {
    return (
      <div
        // style={virtualizedListStyle}
        className={`cds--structured-list-row`}
        title={`Transfer ${index + 1} of ${batchListCount}${
          !transfer.description ? "" : `: ${transfer.description}`
        }`}
        key={transfer.reference}
      >
        <div className="cds--structured-list-td font-ctm--semibold text-primary">
          {index + 1}.
        </div>

        <div
          className="cds--structured-list-td"
          title={
            transfer.isLoadingResolveBeneficiary
              ? "Verifying Recipient..."
              : transfer.isBeneficiaryResolved
              ? "Verified Recipient"
              : "Recipient Could Not Be Verified"
          }
        >
          {transfer.isLoadingResolveBeneficiary ? (
            <CheckboxIndeterminate size="24" color="magenta" />
          ) : transfer.isBeneficiaryResolved ? (
            <CheckmarkFilled size="24" color="#00cf90fa" />
          ) : (
            <CheckmarkFilledError size="24" color="red" />
          )}
        </div>

        <div className="cds--structured-list-td">
          <CurrencyDisplay
            amount={transfer.amount!}
            currencyOrSymbol={transfer.currency}
            amountFontSize={16}
            symbolFontSize={12}
          />
        </div>

        <div className="cds--structured-list-td font-ctm--semibold">
          {transfer.beneficiary_id}
        </div>

        <div className="cds--structured-list-td font-ctm--semibold text-primary">
          {transfer.merchant_id_or_code}
        </div>

        <div className="cds--structured-list-td font-ctm--semibold text-teal">
          {transfer.merchantNameHelper}
        </div>

        <div className="cds--structured-list-td font-ctm--semibold ">
          {transfer.gatewayNameHelper}
        </div>

        <div className="cds--structured-list-td" title={transfer.reference}>
          <div className="flex-container justify-content--start align-items--center no-wrap">
            <div className="transaction-id-text modal-header--title">
              <span title={transfer.reference}>
                {truncateStringWithEllipsis(transfer.reference, 15)}
              </span>
            </div>
            <div className="copy-button--container ml-3">
              <CopyButton
                name="copy-reference-button"
                stringToCopy={transfer.reference}
                iconDescription="copy reference"
                className="copy-btn"
              />
            </div>
          </div>
        </div>

        <div className="cds--structured-list-td font-ctm--semibold">
          {transfer.beneficiaryEmail}
        </div>

        <div className="cds--structured-list-td">
          {isLoadingBatchListVerification ? null : (
            <SwitchAppIconButton
              size="sm"
              kind="tertiary"
              onClick={() => toggleGatewayTransferBatchEntryEditMode(index)}
              className="switch-edit-mode--button"
              title={"Edit transfer entry"}
            >
              <Edit
                className="text-primary"
                style={{ width: "30px", height: "30px" }}
              />
            </SwitchAppIconButton>
          )}

          {!transfer.isBeneficiaryResolved &&
          transfer.isErrorResolveBeneficiary ? (
            <SwitchAppIconButton
              size="sm"
              kind="danger"
              onClick={() => reVerifyTransfers(/*index*/)}
              className="delete-transfer--button"
              title="Re-verify transfer recipient"
            >
              <RetryFailed
                className="text-success ml-5"
                style={{ width: "30px", height: "30px" }}
              />
            </SwitchAppIconButton>
          ) : null}
        </div>

        <div className="cds--structured-list-td">
          {isLoadingBatchListVerification ? null : (
            <SwitchAppIconButton
              size="sm"
              kind="danger"
              onClick={() => removeGatewayTransferByIndex(index)}
              className="delete-transfer--button"
              title="Remove recipient from list"
            >
              <TrashCan
                className="text-danger"
                style={{ width: "30px", height: "30px" }}
              />
            </SwitchAppIconButton>
          )}
        </div>
      </div>
    );
  },
  (prevProps, nextProps) =>
    prevProps.index === nextProps.index &&
    prevProps.transfer.recipient_gateway_code ===
      nextProps.transfer.recipient_gateway_code &&
    prevProps.transfer.merchant_id_or_code ===
      nextProps.transfer.merchant_id_or_code &&
    prevProps.transfer.isBeneficiaryResolved ===
      nextProps.transfer.isBeneficiaryResolved &&
    prevProps.transfer.isErrorResolveBeneficiary ===
      nextProps.transfer.isErrorResolveBeneficiary
);
